export default {
  'initial.group.column3d': () => {
    return {
      'zeroPlane.appearing': () => {
        return [
          {
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: 'axis'
          }
        ];
      }
    };
  }
};
